import React from "react";
import {
  Datagrid,
  Filter,
  FunctionField,
  List,
  ReferenceInput,
  Resource,
  SelectInput,
  TextField,
  TextInput,
} from "react-admin";

// Warehouse (secondary) and shipping (tertiary) packagings assigned to projects.
// Each row is a project–packaging pair served by GET /project-packagings/:type/:accountId.

export const PROJECT_PACKAGING_RESOURCES = [
  { name: "projectSecondaryPackaging", label: "Warehouse packaging (secondary)" },
  { name: "projectTertiaryPackaging", label: "Shipping packaging (tertiary)" },
];

const ProjectPackagingFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search by packaging" source="packaging.name" alwaysOn />
    <ReferenceInput
      label="Project"
      source="projectId"
      reference="projects"
      perPage={500}
      sort={{ field: "name", order: "ASC" }}
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const emptyAsDash = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;

export const ProjectPackagingList = (props) => (
  <List
    {...props}
    filters={<ProjectPackagingFilters />}
    sort={{ field: "packaging.name", order: "ASC" }}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Packaging" source="packaging.name" />
      <FunctionField
        label="Functional unit"
        sortBy="packaging.functionalUnit"
        render={(record) => emptyAsDash(record.packaging?.functionalUnit)}
      />
      <FunctionField
        label="Recycled or reused content"
        sortBy="packaging.recycled_or_reused_content"
        render={(record) =>
          emptyAsDash(record.packaging?.recycled_or_reused_content)
        }
      />
      <FunctionField
        label="DB Version"
        sortable={false}
        render={(record) => emptyAsDash(record.packaging?.databaseVersion)}
      />
      <TextField label="Project" source="project.name" />
    </Datagrid>
  </List>
);

const projectPackagingResources = () =>
  PROJECT_PACKAGING_RESOURCES.map(({ name, label }) => (
    <Resource
      key={name}
      name={name}
      options={{ label, menuGroup: "Packaging" }}
      list={ProjectPackagingList}
    />
  ));

export default projectPackagingResources;
